import React, { useState } from 'react';
import './FAQ.css';

function FAQ() {
  const [openItems, setOpenItems] = useState({});

  const toggleItem = (index) => {
    setOpenItems({
      ...openItems,
      [index]: !openItems[index]
    });
  };

  const faqData = [
    {
      question: "How does Herding Helpers work?",
	answer: "Herding Helpers is a network of volunteer producers and helpers, who are available to assist you in any kind of farm emergency--wild fires, storm damage, and more!"
    },
    {
      question: "Is there a cost to use Herding Helpers?",
	answer: "No, there is no cost for using the Basic tier of service."
    },
    {
      question: "What should I do in a life-threatening emergency?",
      answer: "Always call 911 first for life-threatening emergencies. Herding Helpers is designed to supplement emergency services by connecting you with local agricultural assistance, not replace official emergency response."
    },
    {
      question: "Can I offer my services as a helper?",
      answer: "Yes! Sign up for an account and complete your helper profile with your capabilities, equipment, and availability."
    },
    {
      question: "What types of emergencies do Herding Helpers handle?",
      answer: "We assist with agricultural emergencies like livestock escapes, equipment failures, weather-related issues, fires affecting livestock, and other situations where farmers need immediate help with animals or equipment."
    },
    {
      question: "Can I use Herding Helpers on mobile devices?",
      answer: "Yes, our platform is mobile-responsive and works on smartphones and tablets. We're also developing a dedicated mobile app for even better emergency response capabilities."
    },
  ];

  return (
    <div className="faq-page">
      <div className="container">
        <div className="faq-header">
          <h1>Frequently Asked Questions</h1>
          <p>Find answers to common questions about Herding Helpers</p>
        </div>

        <div className="faq-list">
          {faqData.map((item, index) => (
            <div key={index} className={`faq-item ${openItems[index] ? 'open' : ''}`}>
              <button 
                className="faq-question"
                onClick={() => toggleItem(index)}
              >
                <span>{item.question}</span>
                <i className={`fas fa-chevron-${openItems[index] ? 'up' : 'down'}`}></i>
              </button>
              <div className="faq-answer">
                <p>{item.answer}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="faq-contact">
          <h2>Still have questions?</h2>
          <p>Can't find what you're looking for? We're here to help.</p>
          <a href="/contact" className="contact-button">Contact Support</a>
        </div>
      </div>
    </div>
  );
}

export default FAQ;
